import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function SavedSearchIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12166_135382" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12166_135382)"><path d="M33.1667 34.958L22.2083 23.9997C21.375 24.7219 20.4028 25.2844 19.2917 25.6872C18.1806 26.09 17 26.2913 15.75 26.2913C12.75 26.2913 10.2083 25.2497 8.125 23.1663C6.04167 21.083 5 18.5691 5 15.6247C5 12.6802 6.04167 10.1663 8.125 8.08301C10.2083 5.99967 12.7361 4.95801 15.7083 4.95801C18.6528 4.95801 21.1597 5.99967 23.2292 8.08301C25.2986 10.1663 26.3333 12.6802 26.3333 15.6247C26.3333 16.8191 26.1389 17.9719 25.75 19.083C25.3611 20.1941 24.7778 21.2358 24 22.208L35 33.1247L33.1667 34.958ZM15.7083 23.7913C17.9583 23.7913 19.875 22.9927 21.4583 21.3955C23.0417 19.7983 23.8333 17.8747 23.8333 15.6247C23.8333 13.3747 23.0417 11.4511 21.4583 9.85384C19.875 8.25662 17.9583 7.45801 15.7083 7.45801C13.4306 7.45801 11.4931 8.25662 9.89583 9.85384C8.29861 11.4511 7.5 13.3747 7.5 15.6247C7.5 17.8747 8.29861 19.7983 9.89583 21.3955C11.4931 22.9927 13.4306 23.7913 15.7083 23.7913ZM12.625 20.083L13.8333 16.458L10.7917 14.1247H14.4167L15.6667 10.4997L16.9167 14.1247H20.5L17.4583 16.458L18.6667 20.083L15.6667 17.7913L12.625 20.083Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}